export default {
  'new-year-unavailable:btn': 'ОК',
  'new-year-unavailable:title': 'Сервис недоступен <br/> в период праздников',
  'new-year-unavailable:text': 'Открытие счета Kaspi Gold для ребенка будет доступно с 9:00, 3 января'
}
